import React from "react";

function Charts() {
  return (
    <div className="flex w-3/12 h-3/6 m-auto mt-2 justify-center items-center bg-slate-200 rounded-md shadow-md shadow-black text-lg font-bold">
      Charts
    </div>
  );
}

export default Charts;
